import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Header from './components/header';
import Home from './components/home';
import Footer from './components/footer';
import Warning from './components/warning';
import Users from './components/users';
import Truckers from './components/truckers';
import TruckerReg from './components/truckerReg';
import TruckerReg2 from './components/truckerReg2';
import CompanyReg from './components/companyReg';
import Congrats from './components/congrats';
import NotReady from './components/notReady';
import NotFound from './components/notFound';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

class App extends React.Component {
  constructor(props){
    super(props);
  }
  componentDidMount(){
    AOS.init({
      duration : 1000
    })
  }
  render(){
    /*
    let fixedDate = new Date('2019-11-01');
    let presentDate = new Date()
    if(presentDate <= fixedDate)
    */
    if(1 <= 2)
      {return (
        <React.Fragment>
          <Router>
            <Header/>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/user-info" exact component={Users} />
              <Route path="/trucker-info" exact component={Truckers} />
              <Route path="/trucker-registration" exact component={TruckerReg} />
              <Route path="/complete-registration" exact component={TruckerReg2} />
              {/*<Route path="/company-registration" exact component={CompanyReg} /> */}
              <Route path="/congratulations" exact component={Congrats} />
              <Route path="/not-available" exact component={NotReady} />
              <Route path="*" component={NotFound} />
            </Switch>
            <Footer/>
          </Router>
        </React.Fragment>
      );}else{
      return(
        <Warning/>
      )}
  }
}

export default App;
